import { Boolean } from './Boolean'
export default Boolean
